<template>Healthy</template>
  
  <script>
  export default {
    name: 'HealthCheck'
  }
  </script>